import { businessConnectionMst, common } from '@libs/domain';
import { businessConnectionType } from '@libs/enums';
import type { RequestType } from '@libs/templates/mst';
import { MstRegistrationTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { CheckboxField, CheckboxGroupField, useItemNames, withRerender } from '@ps-smart-cp/ppfw-client';
import { useBusinessConnectionItems } from './hooks';
import { businessConnectionMstRegistrationFieldConfig } from './item-config';
import { BusinessConnectionMstRegistration } from './models';
import { fetchMst, register, update } from './repositories';

function PageComponent({ type, ...restProps }: PageProps & Pick<RequestType, 'type'>) {
  const { code } = useBusinessConnectionItems();
  const getCommonLabelName = useItemNames(common.labelNames);
  const requestType =
    type === 'new'
      ? { type, registrationFunction: register }
      : { type, updateFunction: update, fetchFunction: fetchMst };

  return (
    <MstRegistrationTmpl
      mstName={businessConnectionMst.labelNames.businessConnection}
      initMst={BusinessConnectionMstRegistration.init}
      items={{ ...businessConnectionMstRegistrationFieldConfig, code }}
      {...requestType}
      {...restProps}
    >
      {(businessConnectionMst, setBusinessConnectionMst, errorFields) => (
        <>
          <CheckboxGroupField
            items={businessConnectionMstRegistrationFieldConfig}
            obj={businessConnectionMst}
            setObj={setBusinessConnectionMst}
            enumType={businessConnectionType.enum}
            enumNameConfig={businessConnectionType.nameConfig}
            prop="businessConnectionClass"
            errorFields={errorFields}
          />
          <CheckboxField
            items={businessConnectionMstRegistrationFieldConfig}
            labelName={getCommonLabelName('eligibleBillingProvider')}
            prop="eligibleBillingProvider"
            obj={businessConnectionMst}
            setObj={setBusinessConnectionMst}
          />
        </>
      )}
    </MstRegistrationTmpl>
  );
}

const Registration = withRerender(PageComponent, 'Registration');

export { Registration };
